import { useState } from "react";
import * as Dati from "src/Dati";

const useDerogation = () => {
    const [DerogationFieldsList, setDerogationFieldsList] = useState<Dati.TListaParametriDeroga>({});

    const OnChangeDerogation = (e: React.FormEvent<any>, tipo: string, verso: string) => {
        const name = e.currentTarget.name;
        let list: Dati.TListaParametriDeroga = { ...DerogationFieldsList };

        if (e.currentTarget.checked) {
            list[name] = new Dati.CTipoCampoDeroga();
            list[name].Tipo = tipo;
            list[name].Verso = verso;
        } else if (list[name]) {
            delete list[name];
        }

        setDerogationFieldsList(list);
    };

    return {
        DerogationFieldsList,
        OnChangeDerogation
    };
};

export default useDerogation;



// WEBPACK FOOTER //
// ./src/inar2/hooks/Derogation.ts